export const getCarrierTheme = (stylesAndThemes, carrierName) => {
  for (var eachTheme in stylesAndThemes) {
    if (eachTheme !== "GlobalStyle") {
      if (stylesAndThemes[eachTheme].carrierName === carrierName) {
        return stylesAndThemes[eachTheme]
      }
    }
  }
}